import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Zap, Shield, Clock, Sparkles } from 'lucide-react';

const LandingPage = () => {
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();
  // Using local logo from public folder
  const logoUrl = "/delhi-metro-logo.png";

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleChatOpen = () => {
    navigate('/chat');
  };

  return (
    <div className="landing-container">
      {/* Animated Background Orbs */}
      <div className="bg-gradient-orb orb-1"></div>
      <div className="bg-gradient-orb orb-2"></div>
      <div className="bg-gradient-orb orb-3"></div>

      {/* Shooting Stars */}
      <div className="shooting-star star-1"></div>
      <div className="shooting-star star-2"></div>
      <div className="shooting-star star-3"></div>

      {/* Decorative Geometric Shapes */}
      <div className="geometric-shape shape-1"></div>
      <div className="geometric-shape shape-2"></div>
      <div className="geometric-shape shape-3"></div>

      {/* Main Content */}
      <div className={`landing-content ${mounted ? 'mounted' : ''}`}>
        
        {/* Centered Hero Section */}
        <div className="hero-section">
          <div className="logo-container-landing">
            <div className="logo-glow-ring"></div>
            <img 
              src={logoUrl} 
              alt="Delhi Metro Logo" 
              className="landing-logo"
            />
          </div>
          
          <h1 className="brand-title brand-title-animated">
            <span className="brand-name">MITRA</span>
            <span className="brand-dot">.</span>
            <span className="brand-ai">AI</span>
          </h1>
          
          <p className="brand-subtitle gradient-text">
            Maintenance Intelligence & Troubleshooting Application
          </p>

          {/* Sanskrit Tagline */}
          <div className="tagline-landing">
            <div className="tagline-glow-bg pulsing"></div>
            <h2 className="sanskrit-text">तथ्यं | तन्त्रं | मित्रम्</h2>
          </div>

          {/* Enhanced CTA Button */}
          <button className="cta-button-premium" onClick={handleChatOpen}>
            <span className="cta-gradient-bg"></span>
            <MessageCircle className="cta-icon" size={20} />
            <span className="cta-text">Start Conversation</span>
            <div className="cta-shimmer-premium"></div>
            <div className="cta-pulse-ring"></div>
          </button>
        </div>

        {/* Enhanced Features Section */}
        <div className="features-grid staggered-animation">
          <div className="feature-card-premium" style={{ animationDelay: '0.1s' }}>
            <div className="card-glow-border"></div>
            <div className="feature-icon-premium">
              <Zap size={24} className="icon-animated" />
            </div>
            <h3 className="feature-title">Instant Solutions</h3>
            <p className="feature-desc">Get immediate resolution of RS failures</p>
          </div>

          <div className="feature-card-premium" style={{ animationDelay: '0.2s' }}>
            <div className="card-glow-border"></div>
            <div className="feature-icon-premium">
              <Shield size={24} className="icon-animated" />
            </div>
            <h3 className="feature-title">Reliable Intelligence</h3>
            <p className="feature-desc">AI-powered troubleshooting assistance</p>
          </div>

          <div className="feature-card-premium" style={{ animationDelay: '0.3s' }}>
            <div className="card-glow-border"></div>
            <div className="feature-icon-premium">
              <Clock size={24} className="icon-animated" />
            </div>
            <h3 className="feature-title">24/7 Availability</h3>
            <p className="feature-desc">Always ready to assist your team</p>
          </div>
        </div>

        {/* Footer */}
        <div className="landing-footer">
          <p className="footer-text">Powered by Delhi Metro Rail Corporation</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
